// Force page title to always remain Customer Hub (prevent external overrides)
const HUB_PAGE_TITLE = "Customer Hub";

function lockHubTitle() {
  if (document.title !== HUB_PAGE_TITLE) {
    document.title = HUB_PAGE_TITLE;
  }
}

// Initial set
document.title = HUB_PAGE_TITLE;

// Observe title changes and reset if modified
const titleObserver = new MutationObserver(lockHubTitle);
const titleElement = document.querySelector("title");
if (titleElement) {
  titleObserver.observe(titleElement, { childList: true });
}
document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.hub-tab');
    const panels = document.querySelectorAll('.hub-tab-panel');
    const welcomeSection = document.querySelector('.hub-welcome-section');

    const pageMap = {
      wishlist: '/pages/wishlist',
      support: '/pages/help-center'
    };

    const rewardsUrls = {
      loggedIn: '/pages/our-story?view=loyalty-member',
      loggedOut: '/pages/our-story?view=loyalty'
    };


    tabs.forEach(tab => {
      tab.addEventListener('click', async () => {
        const allTabs = document.querySelectorAll('.hub-tab');
        const allPanels = document.querySelectorAll('.hub-tab-panel');

        allTabs.forEach(t => t.classList.remove('active'));
        allPanels.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');
        // Update URL hash without reload
        if (tab.dataset.target) {
          history.replaceState(null, null, `#${tab.dataset.target}`);
        }
        const target = tab.dataset.target;
        const panel = document.getElementById(`hub-tab-${target}`);
        if (!panel) return;

        panel.classList.add('active');
        if (welcomeSection) {
          if (target === 'home') {
            welcomeSection.classList.remove('hidden');
          } else {
            welcomeSection.classList.add('hidden');
          }
        }

        if (target === 'wishlist') {
          await loadPage(pageMap.wishlist, panel);
        }

        if (target === 'rewards') {
          const isLoggedIn = document.body.classList.contains('logged_in');

          const rewardsUrl = isLoggedIn ? rewardsUrls.loggedIn : rewardsUrls.loggedOut;
          await loadRewardsPage(rewardsUrl, panel);
        }

        sessionStorage.setItem('activeCustomerTab', target);
      });
    });


   const activateTabFromHash = () => {
    let hash = window.location.hash.replace('#', '');

    // remove query params after hash
    hash = hash.split('?')[0];

    if (!hash) return false;

    const hashTab = document.querySelector(
      `.hub-tab[data-target="${hash}"]`
    );

    if (hashTab) {
      hashTab.click();
      return true;
    }

    return false;
  };

    if (!activateTabFromHash()) {
      const savedTab = sessionStorage.getItem('activeCustomerTab');
      if (savedTab) {
        const savedTabEl = document.querySelector(`.hub-tab[data-target="${savedTab}"]`);
        if (savedTabEl) {
          savedTabEl.click();
        }
        sessionStorage.removeItem('activeCustomerTab');
      }
    }

    window.addEventListener('hashchange', activateTabFromHash);

    const overlay = document.querySelector('.hub-modal-overlay');

    function openModal(modal) {
      if (!modal) return;
      overlay?.classList.remove('hidden');
      modal.classList.remove('hidden');
    }

    function closeAllModals() {
      overlay?.classList.add('hidden');
      document.querySelectorAll('.hub-modal').forEach(m => m.classList.add('hidden'));
    }

    document.addEventListener('click', e => {

      if (e.target.closest('.js-edit-profile')) {
        e.preventDefault();
        // openModal(document.getElementById('edit_profile_modal'));
        sessionStorage.setItem('openAccountProfileEdit', 'true');
        window.location.href = 'https://accounts.shadyrays.com/profile';
        return;
      }

      if (e.target.closest('.js-add-address')) {
        e.preventDefault();
        openModal(document.getElementById('add_address'));
        return;
      }

      const editBtn = e.target.closest('.js-edit-address');
      if (editBtn) {
        e.preventDefault();
        const id = editBtn.getAttribute('data-modal-id') || editBtn.getAttribute('aria-owns');
        openModal(document.getElementById(id));
        return;
      }

      if (e.target.closest('.js-close-modal') || e.target === overlay) {
        e.preventDefault();
        closeAllModals();
        return;
      }

    });


    document.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', () => {
        sessionStorage.setItem('activeCustomerTab', 'profile');
      });
    });

    document.querySelectorAll('.hub-link').forEach(link => {
      link.addEventListener('click', async e => {
        e.preventDefault();
        const targetTab = "rewards";
        const targetPanel = document.getElementById(`hub-tab-rewards`);
        if (!targetPanel) return;

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        const targetTabElement = document.querySelector(`.hub-tab[data-target=rewards]`);
        if (targetTabElement) {
          targetTabElement.classList.add('active');
        }
        targetPanel.classList.add('active');

        if (welcomeSection) {
          if (targetTab === 'home') {
            welcomeSection.classList.remove('hidden');
          } else {
            welcomeSection.classList.add('hidden');
          }
        }

        if (targetTab === 'rewards') {
          const isLoggedIn = document.body.classList.contains('logged_in');
          const rewardsUrl = isLoggedIn ? rewardsUrls.loggedIn : rewardsUrls.loggedOut;
          await loadRewardsPage(rewardsUrl, targetPanel);

          const rewardsPanel = document.getElementById('hub-tab-rewards');

          const scrollWhenReady = () => {
            const yotpoSection = rewardsPanel?.querySelector('.yotpo-vip-tiers-widget');
            if (yotpoSection) {
              yotpoSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              return true;
            }
            return false;
          };

          if (!scrollWhenReady()) {
            const observer = new MutationObserver(() => {
              if (scrollWhenReady()) {
                observer.disconnect();
              }
            });

            observer.observe(rewardsPanel, {
              childList: true,
              subtree: true
            });
          }
        }

        sessionStorage.setItem('activeCustomerTab', targetTab);
      });
    });
  });


  async function loadPage(url, container) {
    if (container.dataset.loaded === 'true') return;

    const contentTarget = container.querySelector('.wishlist-dynamic-content');
    if (!contentTarget) return;

    contentTarget.innerHTML = '<div class="hub-loader">Loading...</div>';

    const res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const mainContent =
      doc.querySelector('main') ||
      doc.querySelector('#MainContent') ||
      doc.body;

    contentTarget.innerHTML = mainContent.innerHTML;

    container.dataset.loaded = 'true';

    // Reset title in case loaded scripts try to change it
    document.title = HUB_PAGE_TITLE;

    rehydrateScripts(contentTarget);
  }

async function loadRewardsPage(url, container) {
  if (container.dataset.loaded === 'true') {
    // Panel already rendered — just re-validate points/tier in the background.
    if (window.SRRewards) window.SRRewards.load();
    return;
  }

  container.innerHTML = '<div class="hub-loader">Loading rewards...</div>';

  // load Yotpo loader FIRST (like wishlist loads its app before content shows)
  loadYotpoRewardsScript();

  // wait for Yotpo loader to initialize
//   await new Promise(resolve => setTimeout(resolve, 2500));

  let res;
  try {
    res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      cache: 'no-store' // never reuse a cached (possibly logged-out) copy
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
  } catch (err) {
    console.error('Rewards page failed to load', err);
    container.innerHTML = '<div class="hub-loader">We couldn’t load your rewards. <a href="#rewards" onclick="location.reload()">Reload</a></div>';
    return;
  }

  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const mainContent =
    doc.querySelector('main') ||
    doc.querySelector('#MainContent') ||
    doc.body;

  container.innerHTML = mainContent.innerHTML;
  container.dataset.loaded = 'true';

  // Reset title in case loaded scripts try to change it
  document.title = HUB_PAGE_TITLE;

  rehydrateScripts(container);

  await waitForYotpoLoyalty(container);

  if (window.yotpoWidgetsContainer) {
    window.yotpoWidgetsContainer.initWidgets();
  }
}

  function rehydrateScripts(container) {
    const scripts = container.querySelectorAll('script');
    scripts.forEach(oldScript => {
      if (oldScript.src && document.querySelector(`script[src="${oldScript.src}"]`)) {
        oldScript.remove();
        return;
      }

      const newScript = document.createElement('script');
      if (oldScript.src) {
        newScript.src = oldScript.src;
        newScript.async = oldScript.async;
      } else {
        newScript.textContent = oldScript.textContent;
      }
      document.body.appendChild(newScript);
      oldScript.remove();
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    const homeTab = document.getElementById('hub-tab-home');
    if (!homeTab) return;

    const summaryList = homeTab.querySelector('.hub-home-orders');
    const receiptsWrapper = homeTab.querySelector('.home-order-receipts');

    document.addEventListener('click', e => {
      const btn = e.target.closest('.js-view-order');
      if (!btn) return;

      const card = btn.closest('#hub-tab-home .order-card');
      if (!card) return;

      e.preventDefault();

      const orderId = btn.dataset.orderId;
      const receipt = receiptsWrapper.querySelector(
        `.home-order-receipt[data-order-id="${orderId}"]`
      );

      if (!receipt) return;

      summaryList.classList.add('hidden');
      receiptsWrapper.classList.remove('hidden');

      receiptsWrapper
        .querySelectorAll('.home-order-receipt')
        .forEach(r => r.classList.add('hidden'));

      receipt.classList.remove('hidden');
      receipt.scrollIntoView({ behavior: 'smooth' });
    });

    document.addEventListener('click', e => {
      if (!e.target.classList.contains('back-to-home-orders')) return;

      receiptsWrapper.classList.add('hidden');
      summaryList.classList.remove('hidden');

      receiptsWrapper
        .querySelectorAll('.home-order-receipt')
        .forEach(r => r.classList.add('hidden'));
    });
  });

function waitForYotpoLoyalty(container) {
  return new Promise(resolve => {
    let attempts = 0;
    const maxAttempts = 40; // ~8 seconds

    const interval = setInterval(() => {
      const yotpoLoaded =
        container.querySelector('.yotpo-widget-instance') ||
        container.querySelector('[class*="yotpo"]') ||
        window.yotpo;

      attempts++;

      if (yotpoLoaded || attempts >= maxAttempts) {
        clearInterval(interval);
        resolve();
      }
    }, 200);
  });
}

function loadYotpoRewardsScript() {
  // Don't inject the Yotpo loader again if the layout already has it —
  // multiple loaders race each other and can render stale/0-point widgets.
  if (document.querySelector('script[src*="cdn-widgetsrepository.yotpo.com/v1/loader/5XXEQQHzTPRoDofnM2jF3g"]')) return;

  const script = document.createElement('script');
  script.src = 'https://cdn-widgetsrepository.yotpo.com/v1/loader/5XXEQQHzTPRoDofnM2jF3g';
  script.async = true;
  script.setAttribute('data-yotpo-rewards-script', 'true');

  document.body.appendChild(script);
}
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const container = document.querySelector(".hub-benefit-cards");
    if (container) {
      const scrollAmount = (container.scrollWidth - container.clientWidth) / 2;
      container.scrollLeft = scrollAmount;
    }
  }
});